export default "__VITE_ASSET__Dy$xQbNB__"